<div class="bary-input-checkbox">
  <mdb-checkbox
    [default]="true"
    #mdbCheckbox
    [inline]="inline"
    [id]="id"
    [mdbValidate]="true"
    [validateSuccess]="false"
    [attr.disabled]="disabled"
    [class.ng-invalid]="control.invalid"
    [formControl]="control"
    (change)="onChangeEvent.emit($event)"
    [name]="id"
    >{{ label }}
    <ng-content></ng-content>
    <span class="asterisk" *ngIf="isRequired"></span>
    <mdb-icon *ngIf="tooltip" fas icon="question-circle" class="ml-1" [mdbTooltip]="tooltip"></mdb-icon>
  </mdb-checkbox>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
    <span *ngIf="control.hasError('customMessage')" [jhiTranslate]="control?.errors?.customMessage"></span>
  </mdb-error>
</div>
